"use client";

import React from "react";
import { ArrowRight } from "@mui/icons-material";
import { NodeModel, useDragOver } from "@minoru/react-dnd-treeview";
import { Icon, Stack, Typography } from "@mui/material";
import { useTheme } from "@cbex/utils/theme";
import { useTranslations } from "next-intl";

interface CustomDrawerNodeProps {
  node: NodeModel;
  depth: number;
  hasChild: boolean;
  onToggle: (id: string | number) => void;
  isOpen: boolean;
  onSelect: (node: NodeModel) => void;
  isSelected: boolean;
}

export const CustomDrawerNode = ({
  onToggle,
  depth,
  isOpen,
  node,
  onSelect,
  isSelected,
  hasChild,
}: CustomDrawerNodeProps) => {
  const { id, data } = node;

  const t = useTranslations("common");
  const theme = useTheme();
  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onToggle(node.id);
  };

  const handleSelect = () => onSelect(node);

  // const dragOverProps = useDragOver(id, isOpen, onToggle);

  return (
    <Stack
      id={`CustomDrawerNode${id}`}
      direction={"row"}
      sx={{
        width: "100%",
        // marginBottom: depth === 0 ? "8px" : 0,
        backgroundColor: isSelected ? theme.appPalette.tertiary[60] : "inherit",
        color: theme.appColors.primary,
        borderRadius: 8,
        padding: 4,
        alignItems: "center",
        cursor: "pointer",
        "&:hover": {
          background: theme.appPalette.tertiary[70],
        },
      }}
      height={theme.dimensions.appDrawerItemHeight}
      // {...dragOverProps}
    >
      <Stack direction={"row"} width={"100%"} alignItems={"center"}>
        <Stack
          width={"100%"}
          spacing={4}
          direction={"row"}
          alignItems={"center"}
          onClick={(event) => {
            handleSelect();
          }}
        >
          <Stack width={"20px"}>
            {
              //@ts-ignore
              data.icon !== "" && (
                <Icon
                  // baseClassName="material-icons-outlined"
                  sx={{
                    color: "inherit",
                    height: 24,
                    width: 24,
                  }}
                >
                  {
                    //@ts-ignore
                    data.icon
                  }
                </Icon>
              )
            }
          </Stack>
          {/* </WcIcon> */}
          <Typography variant="body1">{t(node.text)}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
